<template>
    <div>
        <b-modal title="Шүүх" v-model="showMdl" @hide="$emit('on-hide')" ok-title="Шүүлт хийх" cancel-title="Хаах" @ok="doSearch()">
            <form class="pd-10">
                <div class="form-group">
                    <label >Эхлэх огноо</label>
                    <DatePicker
                        v-model="$data['d1']"
                        placeholder="Огноо сонгоно уу"
                        type="datetime"
                        style="width: 100%"
                        :format="'yyyy-MM-dd HH:mm:ss'"
                        :value-format="'yyyy-MM-dd HH:mm:ss'"
                    ></DatePicker>
                </div>

                <div class="form-group">
                    <label >Дуусах огноо</label>
                    <DatePicker
                        v-model="$data['d2']"
                        placeholder="Огноо сонгоно уу"
                        type="datetime"
                        style="width: 100%"
                        :format="'yyyy-MM-dd HH:mm:ss'"
                        :value-format="'yyyy-MM-dd HH:mm:ss'"
                    ></DatePicker>
                </div>
            </form>
        </b-modal>
    </div>
  </template>
  
<script>
import "element-ui/lib/theme-chalk/index.css";
import { Form, FormItem, DatePicker } from "element-ui";

  export default {
    components:{
        Form, FormItem, DatePicker
    },
      props:{
        mdl: {
          type: Boolean,
          default: () => false,
        },
      },
      data(){
        return{
            showMdl: false,
            d1: null,
            d2: null,
        }
      },
      computed: {
            frmId() {
            return this.mdl;
            }
        },
      watch: {
            frmId(val) {
            if (val) {
                this.init();
            }
            }
      },
      methods:{
        init(){
            this.showMdl= true;
        },
        doSearch(){
            this.$emit('do-search', {d1: this.d1, d2: this.d2});
        }
      }
  }
  </script>
  
  <style>
  
  </style>